import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Registration from './Component/Registration';
import Login from './Component/Login';
import Appbar from './Component/Appbar';
import Sidebar from './Component/Sidebar';
import Dashboard from './Component/Dashboard';
import BuyBnbConnect from './Component/BuyBnbConnect';
import BuyReport from './Component/BuyReport';
import DownlineReport from './Component/DownlineReport';
import SellReport from './Component/SellReport';
import WithdrawalReport from './Component/WithdrawalReport';
import SellToken from './Component/SellToken';
import Withdrawal from './Component/Withdrawal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <App /> */}
     <HashRouter>
     <Routes>
      <Route path='/' element={<Login />} />
      <Route path='/registration' element={<Registration />} />
      <Route path='/appbar' element={<Appbar />} />
      <Route path='/sidebar' element={<Sidebar />} />
      <Route path='/dashboard' element={<Dashboard />} />
      <Route path='/bnbconnect' element={<BuyBnbConnect />} />
      <Route path='/buyreport' element={<BuyReport />} />
      <Route path='/downline' element={<DownlineReport />} />
      <Route path='/sellreport' element={<SellReport />} />
      <Route path='/withdrareport' element={<WithdrawalReport />} />
      <Route path='/selltoken' element={<SellToken />} />
      <Route path='/withdrawal' element={<Withdrawal />} />
     </Routes>
     </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
